import { ENERGY_GUZZLERS } from '../../EnergyGuzzlersPageContent/consts';
import { EnergyGuzzler } from '../../EnergyGuzzlersPageContent/types';

export default function getEnergyGuzzlersFlatList() {
  return ENERGY_GUZZLERS.reduce((list, group) => {
    return list.concat(group.items);
  }, [] as EnergyGuzzler[]);
}
